import React from "react";
import { Temporal } from "@js-temporal/polyfill";

import { FulfillmentMethod } from "../types/catalog";
import { StreamlineIcon } from "src/components/icons";
import arrowDown1IconUrl from "images/icons/arrow-down-1.svg";
import timeClockCircleIconUrl from "images/icons/time-clock-circle.svg";

const FulfillmentTimeSelector = ({
  selectedTime,
  fulfillmentMethod,
  fulfillmentTimeOptions
}: {
  selectedTime: Temporal.ZonedDateTime | null;
  fulfillmentMethod: FulfillmentMethod;
  fulfillmentTimeOptions: Array<Temporal.ZonedDateTime>;
}) : React.JSX.Element => {
  const timeOptions = fulfillmentTimeOptions.map(t => {
    const opts : Intl.DateTimeFormatOptions = {
      hour: "numeric",
      minute: "numeric",
    };

    const right = t.toLocaleString("en-NZ", opts);
    const left = (t.subtract({ minutes: 10 })).toLocaleString("en-NZ", opts);

    switch (fulfillmentMethod) {
      case "delivery":
        return (<option value={t.toString()} key={t.toString()}>{left} - {right}</option>);

      case "pickup":
        return (<option value={t.toString()} key={t.toString()}>{right}</option>);
    }
  });

  return (
    <div className="select has-prefix-icon has-end-icon space-mb-none">
      <label htmlFor="overlay_delivery_time">Time</label>
      <span>
        <StreamlineIcon href={timeClockCircleIconUrl} />

        <select name="delivery_time" id="delivery_time" defaultValue={selectedTime?.toString()}>
          <option value="ASAP">ASAP</option>

          {timeOptions}
        </select>

        <StreamlineIcon href={arrowDown1IconUrl} />
      </span>
    </div>
  );
}

export { FulfillmentTimeSelector };
